import React from 'react';
import { useForm, useFieldArray } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

export default function NumberChild({ register, getValues,errors,control }) {
const { t } = useTranslation();
  const { fields, append, remove } = useFieldArray({
  control,
    name: 'children_age',
  });



  return (
 

  <div className="col-md-6">
    <div className='input-block mb-3'>
     <label htmlFor='children_age' className="form-label">{t("Children Ages")}</label>


    {fields.length === 0 && (
      <div className="mb-2">
        <button
          type="button"
          className="btn btn-success"
          onClick={() => append()}
        >
          + {t("Add Child Age")}
        </button>
      </div>
    )}

    {fields.map((field, index) => (
      <div key={field.id} className="d-flex align-items-center gap-2 mb-2">
        <input
          type="number"
          {...register(`children_age.${index}`)}
          className="form-control flex-fill"
          id={`children_age.${index}`}
        />

        
          <button
            type="button"
            className="btn btn-danger flex-fill"
            onClick={() => remove(index)}
          >
            {t("Remove")}
          </button>
       

        {index === fields.length - 1 && (
          <button
            type="button"
            htmlFor={`children_age.${index}`}
            className="btn btn-success flex-fill"
            onClick={() => {
              const lastValue = Number(getValues(`children_age.${fields.length - 1}`));
     
              if (lastValue >= 0) {
                append();
                
              }
            }}
          >
            {t("Add")}
          </button>
        )}
      </div>
    ))}

    {/* Error display */}
    {fields.map((_, index) => (
      errors.children_age?.[index] && (
        <div key={index} className="text-danger">
          {errors.children_age[index]?.message}
        </div>
      )
    ))}
    </div>
  </div>


   
  
  );
}
NumberChild.propTypes = {
    register: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    control: PropTypes.object.isRequired,
    getValues: PropTypes.func.isRequired,
};

